"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);
  function _default() {
    _classCallCheck(this, _default);
    return _callSuper(this, _default, arguments);
  }
  _createClass(_default, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        question = _this$props.question,
        thead = _this$props.thead,
        tbody = _this$props.tbody,
        tableClassName = _this$props.tableClassName,
        settings = _this$props.settings,
        addRowButton = _this$props.addRowButton,
        playerTemplateProps = _this$props.playerTemplateProps,
        elementStyle = _this$props.elementStyle;

      // this is the hack to show matrix with assistant
      var hasCornerAssistant = playerTemplateProps && playerTemplateProps.playerTemplateSettings && playerTemplateProps.playerTemplateSettings.assistant && playerTemplateProps.playerTemplateSettings.assistantPosition === 'corner';
      var hasBubbleMessage = playerTemplateProps && playerTemplateProps.currentBubbleMessage;
      var isQuestionOnTop = !!(hasCornerAssistant && !hasBubbleMessage);
      var assistantSize = '150px';
      return /*#__PURE__*/_react["default"].createElement("div", null, isQuestionOnTop && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          minHeight: assistantSize,
          marginBottom: '1em'
        }
      }, question && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          minHeight: assistantSize
        },
        className: _common["default"].elementWrapper + ' ' + _common["default"][elementStyle]
      }, question)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].elementWrapper + ' ' + _common["default"][elementStyle],
        style: isQuestionOnTop ? {
          marginRight: "calc(-1em - ".concat(assistantSize, ")")
        } : {}
      }, !isQuestionOnTop && question && /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].margin
      }, question), settings.rows && (settings.rows.length > 0 || settings.columns.length > 0) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          overflow: 'auto'
        }
      }, /*#__PURE__*/_react["default"].createElement("table", {
        className: tableClassName
      }, /*#__PURE__*/_react["default"].createElement("thead", null, thead), /*#__PURE__*/_react["default"].createElement("tbody", null, tbody))), settings.allowUserRows && addRowButton)));
    }
  }]);
  return _default;
}(_react["default"].Component);
_defineProperty(_default, "propTypes", {
  // React component which renders question
  question: _propTypes["default"].node,
  // Button to add user row
  addRowButton: _propTypes["default"].node,
  // Class for the table
  tableClassName: _propTypes["default"].string,
  // Render of thead
  thead: _propTypes["default"].node,
  // Render of tbody
  tbody: _propTypes["default"].node,
  // ===========================================================================
  // Advanced props (use them if you know what you are doing)
  // ===========================================================================
  // Object with all open-ended settings
  settings: _propTypes["default"].object,
  // Redux-form field which is associated with the open-ended
  // You can get some form state there. For example:
  //     field.value - array of selected values
  //     field.valid (or opposite field.invalid) - is there any error in answers
  //     field.error - error message if invalid
  //     field.touched - has user already answered the question and moved to another one
  field: _propTypes["default"].object,
  // Array of react component which renders column headers
  // You can render thead like that:
  //     <tr>
  //         {headers.map(column => (
  //             <th key={column.key} className={column.className} style={column.style}>
  //                 {column.content}
  //             </th>
  //         ))}
  //     </tr>
  headers: _propTypes["default"].array,
  // Array with column settings
  columns: _propTypes["default"].array,
  // Array of react component which renders rows
  // You can render tbody like that:
  //     rows.map(row => (
  //         <tr key={row.key}>
  //             {row.columns.map(column => (
  //                 <td key={column.key} className={column.className} style={column.style}>
  //                     {column.content}
  //                 </td>
  //             ))}
  //         </tr>
  //     ))
  rows: _propTypes["default"].array,
  playerTemplateProps: _propTypes["default"].object,
  elementStyle: _propTypes["default"].string
});